import { z } from "zod";

const stateSchema = z
  .string()
  .trim()
  .transform((value) => value.toUpperCase())
  .refine((value) => value.length === 2, {
    message: "Use 2-letter state code",
  });

export const searchSchema = z.object({
  origin_city: z
    .string()
    .trim()
    .min(1, { message: "Please fill out this field" }),
  origin_state: stateSchema.default("CA"),
  destination_city: z
    .string()
    .trim()
    .optional()
    .or(z.literal(""))
    .default(""),
  destination_state: stateSchema.optional().or(z.literal("")).default(""),
  ship_date: z.string().optional().default(() => {
    return new Date().toISOString().split("T")[0];
  }),
  max_weight: z.coerce.number().int().min(0).max(100000).default(45000),
  max_length: z.coerce.number().int().min(0).default(60),
  truck_types: z.array(z.string()).default(["V"]),
  origin_range: z.coerce.number().int().min(0).max(1000).default(100),
  destination_range: z.coerce.number().int().min(0).max(1000).default(100),
  min_distance: z.coerce.number().int().min(0).default(0),
  max_distance: z.preprocess(
    (val) => {
      if (val === "" || val === undefined || val === null) return undefined;
      const n = Number(val);
      return Number.isNaN(n) ? undefined : n;
    },
    z.number().int().min(0).max(3000).optional(),
  ),
  enableBackhaul: z.boolean().default(false),
  enableTruckstop: z.boolean().default(true),
});

const today = new Date().toISOString().split("T")[0];

export const defaultSearchValues = {
  origin_city: "",
  origin_state: "CA",
  destination_city: "",
  destination_state: "",
  ship_date: today,
  max_weight: 45000,
  max_length: 60,
  truck_types: ["V"],
  origin_range: 100,
  destination_range: 100,
  min_distance: 0,
  max_distance: "",
  enableBackhaul: false,
  enableTruckstop: true,
};

